<template>
<b-container fluid id="app">
  <b-row>
    <b-col cols="12">
      <Navigation />
    </b-col>
  </b-row>
  <router-view class="mt-2"></router-view>
</b-container>
</template>
<script>
import Navigation from './components/Navigation.vue'
export default {
  components: {
    Navigation
  },
  beforeCreate() {
    window.sessionStorage.clear()
  },
  created() {
    this.$store.dispatch('setUser', {})
    if (!this.$msal.isAuthenticated()) {
      this.$msal.signIn()
    } else {
      this.$axios.defaults.headers.common['User'] = this.$msal.data.user.idToken.name
      this.$store.dispatch('setUser',this.$msal.data.user)
    }
  }
}
</script>
<style>
body {
  font-size: 1em !important;
}

legend {
  font-size: 1.2em;
}

hr {
  border-top: 1px solid black;
}

legend,
.label {

  font-weight: bold;
}

.modal-header {
  background-color: #150957;
  color: white
}

.errors {
  background-color: pink;
  padding: 0.25em;
  border: 1px solid red;
  font-size: 0.8rem;
  border-radius: 0.4rem;
  font-weight: bold;
  margin-top: 0.2em;
  font-style: italic;
  color: red;
  text-align: center;
}

.darkPurple {
  background-color: #441b59;
  border-color: #441b59;
  color: white;
}

.nav-tabs a {
  font-weight: bold;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
